import React from "react";
import PropTypes from "prop-types";

import "./VideoDestaque.css";

export default function VideoDestaque({
	titulo,
	videoUrl,
	videoTitle,
	backgroundImage,
}) {
	return (
		<section
			className="videoDestaque"
			style={{
				backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
			}}
		>
			<div className="videoDestaque-overlay" aria-hidden="true" />

			<div className="container videoDestaque-container">
				<div className="videoDestaque-card">
					<div className="videoDestaque-header">
						<h2>{titulo}</h2>
					</div>

					<div className="videoDestaque-video">
						<iframe
							src={videoUrl}
							title={videoTitle}
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen
						/>
					</div>
				</div>
			</div>
		</section>
	);
}

VideoDestaque.propTypes = {
	titulo: PropTypes.string.isRequired,
	videoUrl: PropTypes.string.isRequired,
	videoTitle: PropTypes.string.isRequired,
	backgroundImage: PropTypes.string,
};
